import {RootDesc} from "@ui/descriptions/RootDesc";

export const ViewField = ({label, value, customContent, direction = "row"}) => {
  return (
    <li
      className={`relative flex items-start gap-[24rem] flex-${direction}`}
      key={label}
    >
      <RootDesc>
        <b
          className={"block w-[250rem] phone:w-[100%]"}
          dangerouslySetInnerHTML={{__html: label}}
        />
      </RootDesc>

      {customContent ? (
        customContent
      ) : (
        <RootDesc>
          <span
            className={"block p-[4rem_8rem]"}
            dangerouslySetInnerHTML={{__html: value}}
          />
        </RootDesc>
      )}
    </li>
  );
};
